/** @flow */

import React, { Component } from "react";
import Chart from "react-google-charts";
import type { ChartWrapperOptions } from "react-google-charts";
import { chartDefaultColors } from "@styles/colors";

const pieOptions: ChartWrapperOptions = {
  height: 600,
  chartArea: {
    height: 300,
    top: 100,
  },
  legend: {
    position: "top",
  },
  colors: chartDefaultColors,
};

export type Props = $Exact<{
  options?: Object,
  title?: string | React$Node,
  values: Array<Array<string | number>>,
}>;

export class ColumnBarChart extends Component<Props> {
  chartWrapper = null;

  onResize = () => {
    this.chartWrapper && this.chartWrapper.draw();
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    return (
      <div className="w-100">
        <div>{this.props.title}</div>
        <Chart
          chartType="ColumnChart"
          data={this.props.values}
          getChartWrapper={chartWrapper => {
            this.chartWrapper = chartWrapper;
          }}
          options={Object.assign({}, pieOptions, this.props.options)}
        />
      </div>
    );
  }

  static defaultProps = {
    options: {},
  };
}

export default ColumnBarChart;
